import { WorkspaceStatus } from '@lucidlink/dto/validation';
import { workspaceRoutes } from '#services';
export const disableForSuspendedPredicate = ({ workspaceId, workspaceStatus }) => {
    const isSuspended = workspaceStatus === WorkspaceStatus.SUSPENDED;
    if (!isSuspended) {
        return { isSuccess: true };
    }
    else {
        return {
            isSuccess: false,
            navigateTo: workspaceRoutes.workspaceSuspended(workspaceId),
        };
    }
};
